"use strict";

import {hasClass, addClass, removeClass} from './classNameUtils';

export default function Categories() {
  const moveTrigger = document.querySelector('.js-category-trigger');
  const srcContent = document.querySelector('.js-category-src');
  const destContent = document.querySelector('.js-category-dest');
  const overlay = document.querySelector('.js-overlay');

  // Func to move orignal cat content into dropdown and vice versa
  let moveContent = (src, dest) => {
      while (src.childNodes.length > 0) {
          dest.appendChild(src.childNodes[0]);
      } 
  };

  let triggerAppend;
  if(window.innerWidth > 900) {
    triggerAppend = ' Categories';
  } 
  else {
    triggerAppend = '';
  }
  moveTrigger.innerHTML = 'View All' + triggerAppend;

  // When triggered move content and toggle dropdown
  moveTrigger.addEventListener("click", (event) => {
    event.preventDefault();

    if(hasClass(destContent, 'closed') == true){
      moveContent(srcContent, destContent);
      destContent.style.height = destContent.scrollHeight + 'px';
      removeClass(destContent, 'closed');
      addClass(moveTrigger,'active');
      moveTrigger.innerHTML = 'Close All' + triggerAppend;
      addClass(overlay,'active');
    }
    else {
      moveContent(destContent, srcContent);
      addClass(destContent, 'closed');
      removeClass(moveTrigger,'active');
      moveTrigger.innerHTML = 'View All' + triggerAppend;
      removeClass(overlay,'active');
    }
  }, false);

  // Close the cats dropdown & put back src if window resized
  window.addEventListener('resize', () => {
    removeClass(moveTrigger,'active');
    moveContent(destContent, srcContent);
    moveTrigger.innerHTML = 'View All' + triggerAppend;
    addClass(destContent,'closed');
    removeClass(overlay,'active');
  });

};